module.exports = __webpack_public_path__ + "img/home.75b40394.svg";